import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mmt-bracket',
  templateUrl: './mmt-bracket.component.html',
  styleUrls: ['./mmt-bracket.component.css']
})
export class MmtBracketComponent implements OnInit {
  incomeList: any;

  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<MmtBracketComponent>) { 
    this.incomeList = data;
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

}
